import React, { useState, useEffect } from 'react'
import { last } from 'lodash'
import { useSelector } from 'react-redux'
import { Card, Collapse, Grid, IconButton } from '@material-ui/core'
import { ChevronRight, Description } from '@material-ui/icons'
import { useInput } from '../../../hooks/useInput'
import MultiFilesInput from '../../Form/MultiFilesInput'
import FileUploadTable from '../../Form/FileUploadTable'
import TextInput from '../../Form/TextInput'
import { PAYMENT_METHODS } from './ProjectActionsUser'
import Message from '../../Message/Message'

const PaymentMethodButton = ({
  icon: Icon,
  method,
  onClick,
  selected,
  disabled,
}) => {
  return (
    <div
      className={`card-wrapper ${
        selected === method && !disabled ? 'selected' : ''
      }`}
      onClick={() => onClick(method)}
    >
      <Card className="payment-method">
        <div className="center-content">
          <Icon style={{ height: '48px', width: '48px' }} />
          <div className="strong fs16 m-t-8">{method}</div>
        </div>
      </Card>
    </div>
  )
}

const ChooseAPaymentMethod = ({
  bindPurchaseOrderNumber,
  files,
  setFiles,
  setPaymentMethod,
  paymentError,
  noCollapse,
}) => {
  const [filesError, setFilesError] = useState('')

  const { value: filesUploading, setValue: setFilesUploading } = useInput([])

  const { project } = useSelector((state) => state.projectDetails)
  const { success: docSignedSuccess } = useSelector(
    (state) => state.projectDocumentSigned
  )
  const [documentIsSigned, setDocumentIsSigned] = useState(
    noCollapse || last(project.acceptanceCriteria).isSigned
  )
  const [expanded, setExpanded] = useState(documentIsSigned)

  useEffect(() => {
    if (docSignedSuccess) {
      setDocumentIsSigned(true)
      setExpanded(true)
    }
  }, [docSignedSuccess])

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const handlePaymentMethodClick = (method) => {
    // return if the service agreement is not signed
    if (
      last(project.acceptanceCriteria) &&
      !last(project.acceptanceCriteria).isSigned
    ) {
      return
    }

    setPaymentMethod(method)
  }

  return (
    <>
      <div className="flex align-center p-t-24 p-b-24">
        <div>
          {!noCollapse && (
            <IconButton
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
              className={`m-r-10 ${expanded ? 'rotate' : ''}`}
            >
              <ChevronRight />
            </IconButton>
          )}
        </div>
        <div>
          <h2 className="m-b-0 fs20">Enter payment information</h2>
        </div>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className="form-container p-b-24" style={{ maxWidth: 378 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <PaymentMethodButton
                icon={Description}
                method={PAYMENT_METHODS.PURCHASE_ORDER}
                onClick={handlePaymentMethodClick}
                selected={PAYMENT_METHODS.PURCHASE_ORDER}
                disabled={!documentIsSigned}
              />
            </Grid>

            {!documentIsSigned && (
              <Grid item xs={12}>
                <p className="fs12">
                  Please sign service agreement before proceeding to payment.
                </p>
              </Grid>
            )}
          </Grid>
        </div>

        <div className="form-container p-b-24">
          <Grid>
            <Grid xs={12} item className="m-t-16">
              <TextInput
                name="message"
                bindValue={bindPurchaseOrderNumber}
                label="Purchase order number"
                disabled={!documentIsSigned}
              />
            </Grid>
            <Grid xs={12} item className="m-t-16">
              <MultiFilesInput
                name="documents"
                label="Purchase order files"
                filesUploading={filesUploading}
                setFiles={setFiles}
                setFilesUploading={setFilesUploading}
                disabled={!documentIsSigned}
                contentTop={
                  <>
                    Drag and drop or click to add
                    <strong> purchase order files</strong>
                  </>
                }
                error={filesError}
                setError={setFilesError}
              />

              {(files.length > 0 || filesUploading.length > 0) && (
                <FileUploadTable
                  data={files}
                  setData={setFiles}
                  filesUploading={filesUploading}
                />
              )}
            </Grid>
          </Grid>
          {paymentError && <Message variant="error">{paymentError}</Message>}
        </div>
      </Collapse>
    </>
  )
}

export default ChooseAPaymentMethod
